import React from 'react';
import PageHeader from '../pageheader/PageHeader';
import HeadBar from './headBar/HeadBar';
import Input from '../material/input/Input';
import { useState } from 'react';

import { HashLoader } from 'react-spinners';

import useAlert from '../../component/hook/useAlert'

import * as regex from '../../service/regex'
import PasswordInput from '../material/passwordInput/PasswordInput';
import { useNavigate } from 'react-router-dom';

import * as userApi from '../../service/userApi'

function RevocationAccount({

}) {

    const {
        AlertMessage
    } = useAlert()

    const naviagate = useNavigate()

    const [loading, setLoading] = useState(false)
    const [formState, setFormState] = useState({
        "pid": "",
        "username": "",
        "password": ""
    })

    const ApiRevocationAccount = async () => {
        let res = ''
        setLoading(true)
        res = await userApi.RevocationAccount({
            ...formState
        })
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                AlertMessage({
                    title: res['data']['message_th'] || res['data']['message'],
                    onDismiss: () => {
                        onNavigate()
                    }
                })
            } else {
                AlertMessage({
                    title: res['data']['message_th'] || res['data']['message']
                })
            }
        } else {
            AlertMessage({
                title: 'เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่'
            })
        }
    }

    const onSubmit = () => {
        if (!formState['pid']) {
            return AlertMessage({
                title: 'กรุณาระบุเลขบัตรประชาชน'
            })
        }

        if (!formState['username']) {
            return AlertMessage({
                title: 'กรุณาระบุบัญชีผู้ใช้งาน'
            })
        }

        if (!formState['password']) {
            return AlertMessage({
                title: 'กรุณาระบุรหัสผ่าน'
            })
        }

        ApiRevocationAccount()
    }

    const onNavigate = () => {
        naviagate('/')
    }

    return (
        <div className='global-page'>
            <HashLoader loading={loading} style={{ display: 'flex', justifyContent: 'center' }} color="#FF9768" />
            <HeadBar hide_menu={true} />
            <div className='grid justify-center'>

                <PageHeader
                    titlename={'ปิดบัญชีผู้ใช้งาน'}
                />

                <div className='text-[#2E2E2E] font-bold my-3 text-center'>
                    กรุณากรอกข้อมูลเพื่อปิดบัญชี
                </div>
                <div className='w-[530px] grid gap-4 md:w-[300px] md:gap-1'>
                    <Input
                        placeholder='เลขบัตรประชาชน'
                        regex={regex.pid()}
                        name='pid'
                        value={formState['pid']}
                        validate={formState['pid'] === '' ? true : false}
                        onChangeEvt={(e) => {
                            let {
                                name,
                                value
                            } = e.target


                            setFormState((prevState) => ({
                                ...prevState,
                                [name]: value
                            }))
                        }}

                    />

                    <Input
                        placeholder='บัญชีผู้ใช้งาน (Username)'
                        name='username'
                        value={formState['username']}
                        validate={formState['username'] === '' ? true : false}
                        onChangeEvt={(e) => {
                            let {
                                name,
                                value
                            } = e.target


                            setFormState((prevState) => ({
                                ...prevState,
                                [name]: value
                            }))
                        }}

                    />

                    <PasswordInput
                        placeholder='รหัสผ่าน (Password)'
                        name='password'
                        regex={regex.password()}
                        value={formState['password']}
                        validate={!formState['password'] ? true : false}
                        setValue={(value) => {
                            setFormState((prevState) => ({
                                ...prevState,
                                password: value
                            }))
                        }}
                    />

                    <div className='text-[#526F65] font-medium my-3 text-center break-word'>
                        การปิดบัญชีผู้ใช้งาน หมายความถึง ท่านจะไม่สามารถเข้าใช้งานด้วยบัญชีนี้ได้อีก ยืนยันการปิดบัญชีหรือไม่
                    </div>

                    <div className='grid justify-center gap-4'>
                        <div className='button-theme-pg flex justify-center items-center md:w-[250px] w-[269px] md:h-[30px] h-[37px] bg-gradient-to-r from-[#F26D6D] to-[#F26D6D] rounded-3xl gap-1 shadow-sm shadow-my-red '
                            onClick={() => {
                                onSubmit()
                            }}
                        >
                            <div className='md:text-[12px] text-[#ffffff]'>{'ยืนยันการปิดบัญชี'}</div>
                        </div>

                        <div className='button-theme-pg flex justify-center items-center border-[#A2B5BC] border-[1px]  md:w-[250px] w-[269px] md:h-[30px] h-[37px] bg-[#FFFFFF] rounded-3xl gap-1 shadow-sm '
                            onClick={() => {
                                onNavigate()
                            }}
                        >
                            <div className='md:text-[12px] text-[#A2B5BC]'>{'ยกเลิกการปิดบัญชี'}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
}

export default RevocationAccount;